(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-panel.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Checkbox = svs.ui.reactForm.Checkbox;
const TopHeader = svs.myProfile.react.shared.components.TopHeader;
const _svs$myProfile$react$ = svs.myProfile.react.pages.communicationSettings.personalizationSettings.personalizationSettingsService,
  putCustomersSettingsAsync = _svs$myProfile$react$.putCustomersSettingsAsync,
  getCustomersSettingsAsync = _svs$myProfile$react$.getCustomersSettingsAsync;
const makeSetting = svs.myProfile.react.shared.helpers.makeSetting;
const _svs$myProfile$react$2 = svs.myProfile.react.shared.dialogs,
  showSettingsTechnicalError = _svs$myProfile$react$2.showSettingsTechnicalError,
  showNotLoggedInError = _svs$myProfile$react$2.showNotLoggedInError;
const trackPersonlization = svs.myProfile.react.shared.tracking.trackPersonlization;
const PersonalizationSettingsSkeleton = svs.myProfile.react.pages.communicationSettings.personalizationSettings.PersonalizationSettingsSkeleton;
const _svs$myProfile$consta = svs.myProfile.constants,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;

const PersonalizationSettingsPanel = _ref => {
  let isAdaptContent = _ref.isAdaptContent;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isContentExternal = _React$useState2[0],
    setisContentExternal = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isContentSvs = _React$useState4[0],
    setIsContentSvs = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isPersonalizationSettingsLoaded = _React$useState6[0],
    setIsPersonalizationSettingsLoaded = _React$useState6[1];
  const adaptContentRef = React.useRef(null);
  React.useEffect(() => {
    if (isAdaptContent && adaptContentRef && isPersonalizationSettingsLoaded) {
      adaptContentRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isAdaptContent, isPersonalizationSettingsLoaded]);
  React.useEffect(() => {
    const getCS = async () => {
      try {
        const _await$getCustomersSe = await getCustomersSettingsAsync(),
          settings = _await$getCustomersSe.settings,
          error = _await$getCustomersSe.error;
        if (error) {
          if (error.code === 100005) {
            showNotLoggedInError();
            return;
          }
          showSettingsTechnicalError();
        } else {
          setisContentExternal(settings === null || settings === void 0 ? void 0 : settings.personalizedContentExternal);
          setIsContentSvs(settings === null || settings === void 0 ? void 0 : settings.personalizedContentSvs);
          setIsPersonalizationSettingsLoaded(true);
        }
      } catch (error) {
        showSettingsTechnicalError();
      }
    };
    getCS();
  }, []);

  const updateSettings = async (key, val) => {
    try {
      await putCustomersSettingsAsync(makeSetting(key, val));
      trackPersonlization(key, val);
    } catch (error) {
      showSettingsTechnicalError('Ett fel inträffade när dina inställningar för anpassat innehåll skulle sparas, försök igen senare.');
    }
  };

  const handleContentExternal = e => {
    setisContentExternal(!isContentExternal);
    updateSettings(e.target.value, !isContentExternal);
  };

  const handleContentSvs = e => {
    setIsContentSvs(!isContentSvs);
    updateSettings(e.target.value, !isContentSvs);
  };

  return React.createElement(React.Fragment, null, !isPersonalizationSettingsLoaded && React.createElement(PersonalizationSettingsSkeleton, null), isPersonalizationSettingsLoaded && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "scroll-margin-adapted-content",
    ref: adaptContentRef
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.ADAPT,
    title: titles.ADAPT
  }), React.createElement("p", null, "Vi kan anv\xE4nda din anv\xE4ndardata f\xF6r att l\xE4ttare kunna visa inneh\xE5ll som \xE4r relevant f\xF6r dig."), React.createElement(Checkbox, {
    checked: isContentSvs,
    onChange: handleContentSvs,
    value: "personalizedContentSvs"
  }, "Jag vill ha relevant och anpassat inneh\xE5ll p\xE5 Svenska Spels webbplatser"))), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.OFFERS,
    title: titles.OFFERS
  }), React.createElement("p", null, "Svenska Spel samarbetar med partners med egna kundregister som t ex sociala medier f\xF6r att anpassa annonsering och erbjudanden gentemot dig. Detta g\xF6r vi genom att delge v\xE5ra partners att du \xE4r kund hos oss."), React.createElement(Checkbox, {
    checked: isContentExternal,
    onChange: handleContentExternal,
    value: "personalizedContentExternal"
  }, "Ja, det \xE4r OK."))));
};
svs.myProfile.react.pages.communicationSettings.personalizationSettings.PersonalizationSettingsPanel = PersonalizationSettingsPanel;

 })(window);